import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import DownloadIcon from '@mui/icons-material/Download';
import RevenueList from "../../features/manageRevenue/revenueList";
import { useLazyGetRevenueQuery } from "../../services/revenue";
import Pagination from "../../components/Panigation";
import { isValidInput } from "../../utils/validations";
import IfCan from "../../components/IfCan";

const ManageRevenue = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [getRevenue] = useLazyGetRevenueQuery()
  const getRevenueList = async () => {
    setIsLoading(true);
    try {
      const response = await getRevenue({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
        const totalAmt = (response as any)?.total_amount;
        setTotalAmount(totalAmt || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRevenueList()
  }, [page, debouncedSearchTerm])

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const totalPages = Math.ceil(totalCount / 10);
  return (
    <>
      <IfCan module="Manage Revenue" action="view">
        <div className="main_title">
          <h1>Revenue Management</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Revenue Management
          </p>
        </div>

        <div className="stats_boxes gap_m">
          <div className="cards" onClick={() => navigate("/dashboard/unregistered-users")}>
            <figure>
              <img src="/static/images/money_icon.svg" alt="" />
            </figure>
            <h2>AED {totalAmount || 0}</h2>
            <p>Total Payment Recieved</p>
          </div>
        </div>

        <div className="cards mt_20">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  placeholder="Search..."
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                      setPage(1);
                    }
                  }}
                />
              </Box>
            </div>
          </div>
          <RevenueList data={data} isLoading={isLoading} />
        </div>
        <Pagination
          module={data}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          totalCount={totalCount}
          setPage={setPage}
        />
      </IfCan>
    </>
  );
};

export default ManageRevenue;
